import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';

import Form from 'core/forms/Form';
import Field from 'core/forms/Field';
import Button from 'common/components/Button';
import { InputValidator, EmailPatternValidationRule } from 'core/validation';

import InputTextField from 'common/components/fields/InputTextField';

import { localeStrings as strings } from 'applicationConfig';

import './restorePassword.scss';

@inject('settingsStore')
@observer
class RestorePasswordFormStep0 extends Component {
  onFormSubmit(props, values) {
    const settingsStore = this.props.settingsStore;
    props.userStore
      .sendRestorePasswordEmail(values.login)
      .catch((e) => {
        throw e;
      })
      .then(
        action(() => {
          settingsStore.showSimpleAlert(strings.restorePassword.step0Success);
        })
      );

    return false;
  }

  render() {
    const submitButtonCaption = strings.restorePassword.submitButtonCaptions.step0;
    const isFormSubmitted = this.props.formStore.isFormSubmitted;
    const emailValidator = new EmailPatternValidationRule(strings.generic.errorMessages.invalidEmail);

    return (
      <div>
        <Form
          className="restore-password-form"
          onSubmit={this.onFormSubmit.bind(this, this.props)}
          formStore={this.props.formStore}
        >
          <div className="step-field-group">
            <div className="field-group required-field-group">
              <label className="field-group-label">{strings.login.loginLabel}</label>

              <div className="field-group-value required-field-group">
                <Field component={InputTextField} type="text" name="login" placeholder={strings.login.lblLogin}>
                  <InputValidator>{[ emailValidator ]}</InputValidator>
                </Field>
              </div>
            </div>
          </div>
          <div className="actions">
            <Button
              className="btn btn-primary"
              type="submit"
              disabled={isFormSubmitted || !this.props.formStore.isValid}
            >
              <span className="button-caption">{submitButtonCaption}</span>
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default RestorePasswordFormStep0;



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/RestorePasswordFormStep0.jsx